<template>
    <div class="list" ref="list" v-if="items">
        <div>  
            <div class="row row--service" v-for="item in items" :key="item.id">
                <div class="row__name row__name--service">
                    <div class="row--image" style="background-image: url(&quot;https://api.hilfy.at/storage/uploads/masters/small/c11168ae5f7110f079c1e36a684339529275cc35.jpg&quot;);"></div>
                    <span v-if="item.master !== undefined">
                        {{item.master.first_name}}
                    </span>
                    <span v-else>
                        John Doe
                    </span>
                </div>

                <div class="row__times">
                    <div  class="time"></div>
                    <div  class="time"></div>
                    <div  class="time"></div>
                    <div  class="time"></div>
                    <div  class="time"></div>
                    <div  class="time"></div>
                    <div  class="time"></div>
                    <div  class="time"></div>
                    <div  class="time"></div>
                    <div  class="time"></div>
                    <div  class="time"></div>
                    <div  class="time"></div>
                </div>

                <!-- ONLINE START  -->
                <div class="master-schedule" style="width: 100%; left: 0;">
                    <div class="master-onlines">
                        <div class="master-online" style="width: 100%; left: 0"></div>

<!--                        <div class="master-break" :style="{-->
<!--                            width: `${getBreakWidth(item.break.break_from, item.break.break_till)}`,-->
<!--                            left: `${getBreakOffset(item.break.break_till)}`-->
<!--                        }"></div>-->

                        <div class="master-roads">
                            <div 
                                v-for="request in item.requests" 
                                :key="request.request_id" 
                                class="master-roads__item" 
                                :style="{
                                    'left': drawRoadOffset(request),
                                    'width': drawRoadWidth(request)
                                }" 
                            ></div>
                        </div>
                        <!-- master-break width: break_from, left: 30vw; width: 80px width: break_till - break_from -->
                    </div>
                </div>
                <!-- ONLINE END  -->

                <!-- ORDERS START  -->
                <div class="master-orders"> 
                    
                    <div v-for="(request, i) in item.requests" :key="request.request_id" class="master-order"
                    :style="{
                        width: `${calculateOrder(request).width}`,
                        left: `${calculateOrder(request).left}`,
                        'z-index': `${item.requests.length - i}`
                    }"> 
                        <span class="master-orders_span"> {{request.request_original_id || 0}}</span>
                        <div class="master-order__actual master-order__actual-start" :style="{
                            left: getOrderWidth(request).early.before.offset,
                            width: getOrderWidth(request).early.before.width,
                            'background-color': '#BEB4DC'
                            }"> 
                        </div>

                        <div class="master-order__actual master-order__actual-end" :style="{
                            right: getOrderWidth(request).early.after.offset,
                            width: getOrderWidth(request).early.after.width,
                            'background-color': '#BEB4DC'
                            }">
                        </div>

                        <div class="master-order__late master-order__late-start" :style="{
                            left: getOrderWidth(request).late.before.offset,
                            width: getOrderWidth(request).late.before.width,
                            'z-index': 6
                        }"></div>

                        <div class="master-order__late master-order__late-end" :style="{
                            right: getOrderWidth(request).late.after.offset,
                            width: getOrderWidth(request).late.after.width,
                            'z-index': 5
                        }"></div>
                    </div> 
                </div>
                <!-- ORDERS END  -->

                <!-- STATS START  -->
                <div class="row__stats statistic"> 
                    <div class="statistic-item">
                        <div class="statistic-item__box">
                            <div   
                                :style="{
                                    'background-color':  getStatisticColors(item.metrics.indicator_1),  
                                    height: `${item.metrics.indicator_1}%`,
                                    width: '50%'
                            }"
                            >  
                            </div>
                        </div>
                        <p class="statistic-item__p_orange"
                        :style="{
                        color:  getStatisticColors(item.metrics.indicator_1)  
                        }">{{item.metrics.indicator_1}}%</p>
                    </div>

                    <div class="statistic-item">
                        <div class="statistic-item__box">
                            <div   
                                :style="{
                                    'background-color':  getStatisticColors(item.metrics.indicator_2),  
                                    height: `${item.metrics.indicator_2}%`,
                                    width: '50%'
                            }"
                            >  
                            </div>
                        </div>
                        <p :style="{
                            color: getStatisticColors(item.metrics.indicator_2)
                        }">{{item.metrics.indicator_2}}%</p>
                    </div>

                    <div class="statistic-item">
                        <div class="statistic-item__box">
                            <div   
                                :style="{
                                    'background-color':  getStatisticColors(item.metrics.indicator_3),  
                                    height: `${item.metrics.indicator_3}%`,
                                    width: '50%'
                            }"
                            >  
                            </div>
                        </div>
                        <p :style="{
                            color: getStatisticColors(item.metrics.indicator_3)
                        }">{{item.metrics.indicator_3}}%</p>
                    </div>

                    <div class="statistic-item">
<!--                        <div class="statistic-item__box">-->
<!--                            <div   -->
<!--                                :style="{-->
<!--                                    'background-color':  getStatisticColors(item.metrics.indicator_4),  -->
<!--                                    height: `${item.metrics.indicator_4}%`,-->
<!--                                    width: '50%'-->
<!--                            }"-->
<!--                            >  -->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <p :style="{color: getStatisticColors(item.metrics.indicator_4)}">-->
<!--                          {{item.metrics.indicator_4}}%-->
<!--                        </p>-->
                    </div>
                </div> 
            </div> 
            <!-- STATS START  -->
        </div>   
    </div> 
</template>

<script>
import moment from 'moment';
import {mapMutations} from "vuex";

export default {
    name: 'calendar-list-item',
    props: {
        items: {
            required: true
        },
        isVisible: {
            required: true
        },
    },
    data() {
        return {
            leftOffset: 250,
            timesRow: null,
            utc: -180
        }
    },
    computed: {
        hasScroll() {
            if(!this.$refs.list) {
                return false
            }

            return this.$refs.list.scrollHeight > this.$refs.list.clientHeight
        }
    },
    watch: {
        isVisible(value) {
           if(value) {
               this.setState({
                   key: 'doesListItemsHaveScroll',
                   value: this.hasScroll
               });
           }
        }
    },
    methods: {
        ...mapMutations({
          setState: 'calendar/setState'
        }),
        calculateOrder(item) { 
            const start = 8;  
            const end = 19;   
 
            const from = this.getHours(item.schedule_from) + this.getMinutes(item.schedule_from) / 60 - 8;
            const to = this.getHours(item.schedule_till) + this.getMinutes(item.schedule_till) / 60 - 8; 
             
            return {
                width: (to - from) * this.timesRow + 'px',
                left: `${from * this.timesRow + this.leftOffset}px`
            } 
        },  
        getOrderWidth(item) {    
            const from = this.getHours(item.schedule_from) + this.getMinutes(item.schedule_from) / 60 - 8;
            const fact_from = this.getHours(item.fact_from) + this.getMinutes(item.fact_from) / 60 - 8;
            const startFact = (fact_from - from) * this.timesRow;
               
            const till = this.getHours(item.schedule_till) + this.getMinutes(item.schedule_till) / 60 - 8;
            const fact_till = this.getHours(item.fact_till) + this.getMinutes(item.fact_till) / 60 - 8;
           
            const tillFact = (till - fact_till) * this.timesRow;

            const defaultData =  {
                early: {
                    before: {
                        offset: '0',
                        width: '0'
                    },
                    after: {
                        offset: '0',
                        width: '0'
                    }
                },
                late: {
                    before: {
                        offset: '0',
                        width: '0'
                    },
                    after: {
                        offset: '0',
                        width: '0'
                    }
                }
            };

            if(Math.sign(startFact) === -1) {
                defaultData.early.before.offset = startFact + 'px';
                defaultData.early.before.width = startFact * -1 + 'px'; 
            } 
            else { 
                defaultData.late.before.offset = 0; 
                defaultData.late.before.width = startFact + 'px'; 
            } 

            if(Math.sign(tillFact) === 1) {
                defaultData.early.after.offset = 0;
                defaultData.early.after.width = tillFact + 'px'; 
            }
            else {
                defaultData.late.after.offset = tillFact + 'px'; 
                defaultData.late.after.width = tillFact * -1 + 'px'; 
            }
  
            return defaultData;
        },  
        getStatisticColors(item) {
            let active = "";

            const bad = "#FF3100"; // less 21%
            const soSo = "#F07300";  // less 41%
            const good = "#9BCD82";  // 2less 61%
            const ok = "#FFC100";  // less 81%
            const awesome = "#3493FF";  // more 80%

                
            if(item <= 20) {
                active = bad;
            }
            else if(item >= 20 && item <= 40) {
                active = soSo;
            }
            else if(item >= 40 && item <= 60) {
                active = ok;
            }
            else if(item >= 60 && item <= 80) {
                active = good;
            }
            else if(item > 80 ) {
                active = awesome;
            } 

            return active
        },  
        getBreakWidth(break_from, break_till) {
            const from = this.prepareForBreak(break_from);
            const till = this.prepareForBreak(break_till);
            
            const difference = till - from; 

            return this.timesRow * difference + 'px';
        },
        getBreakOffset(break_from) {
            const from =  this.prepareForBreak(break_from);
            return this.timesRow * (from - 9) + 250 + 'px';
        },

        // helpers
        getHours(data) {
            return moment(data).utc(this.utc).hours()
        },
        getMinutes(data) {
            return moment(data).utc(this.utc).minutes() 
        }, 
        prepareForBreak(data) { 
            if (data == null) {
                return null;
            }

            return parseInt(data.split(':')[0]);
        },
        drawRoadOffset(item) {
            if (item.history == null) {
                return 0;
            }

            const started = item.history.find(({status})=>status==='master_on_the_way');

            const from = this.getHours(started.created_at) + this.getMinutes(started.created_at) / 60 - 8;
              
            return `${from * this.timesRow + this.leftOffset}px`
        },
        drawRoadWidth(item) {
            if (item.history == null) {
                return 0;
            }

            const started = item.history.find(({status})=>status==='master_on_the_way');
            const arrived = item.history.find(({status})=>status==='master_arrived');

            const from = this.getHours(started.created_at) + this.getMinutes(started.created_at) / 60 - 8;
            const to = this.getHours(arrived.created_at) + this.getMinutes(arrived.created_at) / 60 - 8; 

            return (to - from) * this.timesRow + 'px';
        }
    },
    mounted() { 
        this.timesRow = document.querySelectorAll('.row__times')[0].offsetWidth / 12;
    }
}
</script>

<style lang="scss" scoped>
.list {
    height: 70vh;
    width: calc(100% + 15px);
    overflow-y: scroll;
}
</style>